<div class="page">
  <div class="page__container">
    <h1 class="page__title h2">{{ 'mail_templates_title' | translate }}</h1>
    <div class="my-5">
      <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
        <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>mail_templates_tab_general</button>
        <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
          <button ngbDropdownItem translate (click)="nav.select('ADVANCED'); dropdown.innerText = $event.target.innerText">
            mail_templates_tab_general
          </button>
          <button ngbDropdownItem translate (click)="nav.select('USER'); dropdown.innerText = $event.target.innerText">
            mail_templates_tab_user
          </button>
          <button ngbDropdownItem translate (click)="nav.select('IMPORT'); dropdown.innerText = $event.target.innerText">
            mail_templates_tab_import
          </button>
        </div>
      </div>

      <ul
        ngbNav
        #nav="ngbNav"
        class="nav-tabs nav_tab_large_device custom"
        (navChange)="changeType($event.nextId)"
        [(activeId)]="currentType"
      >
        <li [ngbNavItem]="'ADVANCED'">
          <a ngbNavLink translate>mail_templates_tab_general</a>
          <ng-template ngbNavContent>
            <ng-container *ngTemplateOutlet="categoryFilter"></ng-container>
            <ng-container *ngTemplateOutlet="templatesList"></ng-container>
          </ng-template>
        </li>
        <li [ngbNavItem]="'USER'">
          <a ngbNavLink translate>mail_templates_tab_user</a>
          <ng-template ngbNavContent>
            <ng-container *ngTemplateOutlet="templatesList"></ng-container>
          </ng-template>
        </li>
        <li [ngbNavItem]="'IMPORT'">
          <a ngbNavLink translate>mail_templates_tab_import</a>
          <ng-template ngbNavContent>
            <p translate>mail_templates_import_text</p>
            <div class="row align-items-center">
              <wsb-atlas-button class="col-sm-4 mt-2 btn-import" variant="primary" label="mail_import_html" (click)="openFileUpload()">
                ></wsb-atlas-button
              >
            </div>
            <div class="row">
              <wsb-atlas-button
                class="mt-2 col-sm-4 btn-import"
                variant="primary"
                label="mail_templates_import_html"
                (click)="openHtmlEditor()"
              >
                ></wsb-atlas-button
              >
            </div>
          </ng-template>
        </li>
      </ul>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
<ng-template #categoryFilter>
  <div class="form-group row">
    <label for="language" class="col-sm-2" translate>mail_templates_advanced_category</label>
    <div class="col-sm-5">
      <ng-select
        [items]="categories"
        [clearable]="false"
        class="form-control"
        bindValue="idCategory"
        bindLabel="label"
        [(ngModel)]="categorySelected"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="selectCategory($event)"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label">{{ item.shortDescription | translate }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <span>{{ item.shortDescription | translate }}</span>
        </ng-template>
      </ng-select>
    </div>
  </div>
</ng-template>
<ng-template #templatesList>
  <span translate *ngIf="!templates.length && !loadingTemplates">mail_templates_user_empty</span>
  <div class="pages-template-list justify-content-center justify-content-md-between" *ngIf="templates.length">
    <div *ngFor="let template of templates" class="card h-100 text-center mb-5">
      <div class="card-header" *ngIf="template.name">
        {{ template.name }}
      </div>
      <div class="card-body">
        <div class="card-text-full" *ngIf="currentType !== 'USER'">
          <img class="img-responsive" [src]="template.thumbnailUrl" />
        </div>
        <div class="card-text" *ngIf="currentType === 'USER'">
          <img class="img-responsive" src="assets/images/email/mytemplate.png" />
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-center" *ngIf="currentType !== 'USER'">
            <button
              *ngIf="page === 'createEmail'"
              class="btn-secondary w-120 "
              ngbDropdownItem
              translate
              (click)="useTemplateToCreateEmailCampaign(template)"
            >
              common_use
            </button>
            <button *ngIf="page !== 'createEmail'" class="btn-secondary w-120 " ngbDropdownItem translate (click)="useTemplate(template)">
              common_use
            </button>
          </div>

          <wsb-atlas-dropdown
            *ngIf="currentType === 'USER'"
            [label]="'common_actions'"
            variant="secondary dropdown-toggle"
            [roundButton]="false"
          >
            <!-- <button ngbDropdownItem translate (click)="openPreview(previewTemplate,template)">common_preview</button> -->
            <button *ngIf="page === 'createEmail'" ngbDropdownItem translate (click)="useTemplateToCreateEmailCampaign(template)">
              common_use
            </button>
            <button *ngIf="page !== 'createEmail'" ngbDropdownItem translate (click)="useTemplate(template)">common_use</button>
            <button [hidden]="currentType !== 'USER'" ngbDropdownItem translate (click)="openDeleteModal(deleteTemplate, template)">
              common_delete
            </button>
          </wsb-atlas-dropdown>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #deleteTemplate let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="deleteTemplateRef()"
    (dismiss)="d()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'mail_delete_confirm' | translate }}"
  >
  </wsb-modal>
</ng-template>

<ng-template #htmlEditorModal let-c="close" let-d="dismiss">
  <wsb-modal
    (dismiss)="d()"
    cancelButtonEnable="false"
    title="{{ 'mail_templates_import_html_description' | translate }}"
    (primary)="saveHtmlTemplate()"
    [loading]="loading"
  >
    <div body [formGroup]="htmlEditorForm">
      <div class="form-group row">
        <label for="language" class="col-sm-3" translate>mail_template_name</label>
        <input type="text" id="name" name="name" formControlName="name" class="form-control col-sm-4" />
        <wsb-validation-error-msg [fc]="htmlEditorForm.get('name')"></wsb-validation-error-msg>
      </div>
      <ckeditor [editor]="EditorE" formControlName="bodyHtml"></ckeditor>
      <wsb-validation-error-msg [fc]="htmlEditorForm.get('bodyHtml')"></wsb-validation-error-msg>

      <!--       <div class="form-group ">
        <div class="d-flex align-items-center my-2">
          <wsb-ui-checkbox [(checked)]="htmlEditorUseText" class="me-3 pt-1"></wsb-ui-checkbox>
          <span translate>settings_account_mail2sms_pin</span>
        </div>
        <textarea [readonly]="!htmlEditorUseText" style="width: 100%" rows="5" class="form-control" id="bodyText" name="bodyText" formControlName="bodyText"></textarea>
      </div> -->
    </div>
  </wsb-modal>
</ng-template>

<ng-template #importFileModal let-c="close" let-d="dismiss">
  <wsb-modal
    (dismiss)="d()"
    cancelButtonEnable="false"
    title="{{ 'mail_import_html' | translate }}"
    (primary)="uploadFile()"
    [primaryDisabled]="importFileForm.invalid"
    [loading]="loading"
  >
    <div body [formGroup]="importFileForm">
      <div class="form-group row">
        <label for="language" class="col-sm-3" translate>mail_template_name</label>
        <input type="text" id="name" name="name" formControlName="name" class="form-control col-sm-4" />
        <wsb-validation-error-msg [fc]="importFileForm.get('name')"></wsb-validation-error-msg>
      </div>
      <div class="form-group row">
        <label for="file" class="col-sm-3" translate>common_select</label>
        <input type="file" id="file" class="form-control  col-sm-4" #fileInput (change)="onFileUploadChange($event)" />
        <wsb-validation-error-msg [fc]="importFileForm.get('file')"></wsb-validation-error-msg>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #successImportModal let-c="close" let-d="dismiss">
  <wsb-modal
    (dismiss)="d()"
    cancelButtonEnable="false"
    title="{{ 'common_preview' | translate }}"
    primaryButtonEnable=""
    [loading]="loading"
  >
    <div body class="text-center">
      Bravo !
    </div>
  </wsb-modal>
</ng-template>
